import { WireError } from 'scenes/common/types';
import { MotorFunnelState } from 'scenes/motor/flows/types';

import { toPageName } from './page';

export const toWireError = (
  state: MotorFunnelState,
  type: string,
  message: string
): WireError => ({
  type,
  message,
  pageName: toPageName(state),
});
